const EXTERNAL_MANAGED_PAYMENT_ERROR_MESSAGES: Record<string, string> = {
  INVALID_SERVICE_TYPE:
    'Payment configuration is invalid. Please refresh the page or contact support.',
  EXTERNAL_SERVICE_NOT_FOUND:
    'Institute payment details are not available. Please contact support.',
  EXTERNAL_SERVICE_HAS_NO_ACTIVE_PAYMENT_METHODS:
    'No active payment method is configured. Please contact support.',
  ORDER_NOT_FOUND: 'Your order could not be found. Please refresh and try again.',
  ORDER_NOT_ACTIVE:
    'This order is no longer active for payment submission. Please contact support.',
  ORDER_INSTALLMENT_TYPE_NOT_EXTERNAL_MANAGED:
    'This order cannot be used for external payment verification.',
  INVALID_PAYMENT_AMOUNT: 'Please enter a valid payment amount.',
  PAYMENT_REFERENCE_NUMBER_ALREADY_EXISTS:
    'This UTR / reference number has already been submitted.',
  INVALID_PAYMENT_DATE: 'Please enter a valid payment date (dd-mm-yyyy).',
  MISSING_PAYMENT_FIELDS: 'Please fill all required payment fields.',
  ORDER_ID_NOT_AVAILABLE:
    'Could not create or find your order. Please refresh and try again.',
  MISSING_EXTERNAL_SERVICE_META:
    'Payment instructions are not available. Please contact support.',
  INVALID_PAYMENT_PROOF_S3_KEY:
    'Please upload a valid payment proof screenshot and try again.',
  INVALID_EXTRACTION_ATTEMPT_ID:
    'Payment proof could not be processed. Please upload again.',
  PAYMENT_PROOF_EXTRACTION_FAILED:
    'We could not read payment details from this proof. Please upload a clear screenshot showing amount, date, and transaction ID.',
  PAYMENT_PROOF_EXTRACTION_IN_PROGRESS:
    'Payment proof is still being processed. Please wait.',
  PAYMENT_PROOF_EXTRACTION_ERROR:
    'Please upload a valid payment proof screenshot showing amount, date, and transaction ID.'
};

export const getExternalManagedPaymentErrorMessage = (
  resStatusOrCode: string | undefined
): string => {
  if (!resStatusOrCode) {
    return 'Something went wrong. Please try again.';
  }
  return (
    EXTERNAL_MANAGED_PAYMENT_ERROR_MESSAGES[resStatusOrCode] ??
    'Something went wrong. Please try again.'
  );
};
